import { useGetFeatureFlag } from '@user-portal/experimentation';

import { reasonToModal } from 'modals/CancellationReasonModal/constants';

import { ModalName } from 'types/modals';

type ReturnAssignment = {
    isReallocationEnabled: boolean;
};

const useGetCancellationReasonModal = () => {
    const { getAssignment } = useGetFeatureFlag();

    const getCancellationReasonModal = async (reason: string): Promise<ModalName> => {
        const { isReallocationEnabled } = await getAssignment<ReturnAssignment>({
            type: 'json',
            flagKey: 'offer_reallocation',
            subjectAttributes: { extras: { reason } },
            defaultValue: { isReallocationEnabled: false },
        });

        if (isReallocationEnabled) {
            return ModalName.SPECIAL_OFFER;
        }

        return reasonToModal[reason];
    };

    return { getCancellationReasonModal };
};

export default useGetCancellationReasonModal;
